"use client";

import HeroCopyCompact from "./HeroCopyCompact";
import HeroCopyOverlay from "./HeroCopyOverlay";
import HeroMedia from "./HeroMedia";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slide: HighlightedGameSlide;
  providerName: string;
  logoUrl?: string;
  totalGamesCount?: number;
  randomGameHrefs?: string[];
  providerGameThumbnailUrls?: string[];
  isActive: boolean;
  translations: Record<string, string>;
  onProgress?: (progress: number) => void;
  onComplete?: () => void;
};

const HeroSlide: FC<Props> = ({
  slide,
  providerName,
  logoUrl,
  totalGamesCount,
  randomGameHrefs,
  providerGameThumbnailUrls = [],
  isActive,
  translations,
  onProgress,
  onComplete,
}) => {
  const gamesCount = slide.isProvider ? totalGamesCount : undefined;

  return (
    <div className="flex flex-col overflow-hidden rounded-2xl bg-black md:relative md:isolate md:aspect-video md:min-h-[300px] md:justify-end">
      <div className="relative h-40 w-full md:absolute md:inset-0 md:size-full">
        <HeroMedia
          videoUrl={slide.videoUrl}
          thumbnailUrl={slide.thumbnailUrl}
          alt={slide.thumbnailAlt ?? slide.title}
          isActive={isActive}
          translations={translations}
          onProgress={onProgress}
          onComplete={onComplete}
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-linear-to-b from-transparent from-[47.9%] to-black md:hidden"
        />
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 hidden h-3/5 bg-linear-to-t from-black/95 via-black/50 to-transparent md:block"
      />
      <HeroCopyCompact
        slide={slide}
        providerName={providerName}
        logoUrl={logoUrl}
        totalGamesCount={gamesCount}
        randomGameHrefs={randomGameHrefs}
        thumbnailUrls={providerGameThumbnailUrls}
        translations={translations}
      />
      <HeroCopyOverlay
        slide={slide}
        providerName={providerName}
        logoUrl={logoUrl}
        totalGamesCount={gamesCount}
        randomGameHrefs={randomGameHrefs}
        translations={translations}
      />
    </div>
  );
};

export default HeroSlide;
